import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

@Injectable({
    providedIn: 'root'
})
export class SellService {
    public AddSellData = new BehaviorSubject<any>(null);
    parkSaleData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    ReturnSellData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    UserData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    paymentDataOfCart: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(private http: HttpClient, private commonService: CommonService) { }
    GetTopSellingProduct(obj) {
        if (obj.outletcode) {
            const params = new HttpParams().set('storecode', obj.storecode).set('outletcode', obj.outletcode)
            params.append('Access-Control-Allow-Origin', '*')
                .append('Access-Control-Allow-Headers', '*')
                .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
                .append('Accept', 'application/json');
            return this.http.get(`${environment.baseUrl}Product/GetTopSellingProduct`, { params });
        } else {
            const params = new HttpParams().set('storecode', obj.storecode)
            params.append('Access-Control-Allow-Origin', '*')
                .append('Access-Control-Allow-Headers', '*')
                .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
                .append('Accept', 'application/json');
            return this.http.get(`${environment.baseUrl}Product/GetTopSellingProduct`, { params });
        }
    }
    getOutletRegisterStatus(obj) {
        const params = new HttpParams().set('storecode', obj.storecode).set('registercode', obj.registercode)
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');
        return this.http.get(`${environment.baseUrl}Outlet/OutletRegisterStatus`, { params });
    }
    userRegisterStatus(obj) {
        const params = new HttpParams().set('storecode', obj.storecode).set('usercode', obj.usercode)
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');
        return this.http.get(`${environment.baseUrl}Outlet/userRegisterStatus`, { params });
    }
    GetCustomerDetails(obj, customercode) {
        const params = new HttpParams().set('storecode', obj.storecode).set('customercode', customercode)
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');
        return this.http.get(`${environment.baseUrl}Customer`, { params });
    }
    getSellHistory(obj, id, outletcode, fromdate, todate) {
        if (!obj.sellcode) {
            obj.sellcode = ''
        }
        if (id) {
            obj.sellcode = id
        }
        if (outletcode != '') {
            // console.log(outletcode);
            obj.outletcode = outletcode
        }
        else {
            obj.outletcode = ''
        }
        const headers = new HttpHeaders()
            .set('content-type', 'application/json')
        const params = new HttpParams().set('storecode', obj.storecode)
            .set('referencecode', obj.sellcode)
            .set('outletcode', obj.outletcode)
            .set('fromdate', fromdate)
            .set('todate', todate);
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');

        return this.http.get(`${environment.baseUrl}Sell/Get`, { params: params },);
    }
    getSellHistoryAdvance(obj, id, outletcode, fromdate, todate) {
        if (!obj.sellcode) {
            obj.sellcode = ''
        }
        if (id) {
            obj.sellcode = id
        }
        if (outletcode != '') {
            // console.log(outletcode);
            obj.outletcode = outletcode
        }
        else {
            obj.outletcode = ''
        }
        const headers = new HttpHeaders()
            .set('content-type', 'application/json')
        const params = new HttpParams().set('storecode', obj.storecode)
            .set('referencecode', obj.sellcode)
            .set('outletcode', obj.outletcode)
            .set('fromdate', fromdate)
            .set('todate', todate);
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');

        return this.http.get(`${environment.baseUrl}Sell/GetSellAdvance`, { params: params },);
    }
    getSellHistoryDateFormTo(obj, id, outletcode, from, to, paymentmethod) {
        if (!obj.sellcode) {
            obj.sellcode = ''
        }
        if (id) {
            obj.sellcode = id
        }
        if (from) {
            obj.from = from
        }
        if (to) {
            obj.to = to
        }
        if (outletcode != '') {
            // console.log(outletcode);
            obj.outletcode = outletcode
        }
        else {
            obj.outletcode = ''
        }
        const params = new HttpParams().set('storecode', obj.storecode).set('referencecode', obj.sellcode).set('outletcode', obj.outletcode).set('fromdate', obj.from).set('todate', obj.to).set('paymentmethod', paymentmethod)
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');

        return this.http.get(`${environment.baseUrl}Sell/GetSaleForTax`, { params });
    }
    UpdateRegisterStatus(model) {
        return this.http.put(`${environment.baseUrl}Outlet/UpdateRegisterStatus`, model);
    }
    PaymentMethod(model) {
        return this.http.put(`${environment.baseUrl}sell/PaymentMethod`, model);
    }
    calculateSellDetailTotal(sellDetails) {
        // send existing sell detail array only, backend returns one rounded total.
        return this.http.post(`${environment.baseUrl}sell/CalculateSellDetailTotal`, sellDetails);
    }
    payement(model) {
        return this.http.post(`${environment.baseUrl}sell/PostSell`, model);
    }

    PaymentMethodAdvance(model) {
        return this.http.put(`${environment.baseUrl}sell/PaymentMethodAdvance`, model);
    }
    paymentadvance(model) {
        return this.http.post(`${environment.baseUrl}Sell/selladvance`, model);
    }
    // user api for switch
    UserList(obj) {
        return this.http.get(`${environment.baseUrl}Users/` + obj.storecode + `/` + obj.usercode);
    }
    uploadInvoice(model) {
        const headers = new HttpHeaders()
            .set('content-type', 'application/json')
            .append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');
        return this.http.post(`${environment.baseUrl}FileUpload`, model, { headers: headers });
    }

    // EditOutletAPI(model) {
    //     return this.http.put(`${environment.baseUrl}Outlet`, model);
    // }
    // DeleteOutlet(model) {
    //     const params = {headers: new HttpHeaders({
    //         'Content-Type': 'application/json'
    //       }),
    //       body: {
    //         id:JSON.parse(model.id)
    //       }}
    //     return this.http.delete(`${environment.baseUrl}Outlet`, params).pipe(catchError(this.commonService.handleError));
    // }

    //  Get all pending invoices to push
    getPendingInvoices(storecode: string) {
        const params = new HttpParams().set('storecode', storecode);
        params.append('Access-Control-Allow-Origin', '*')
            .append('Access-Control-Allow-Headers', '*')
            .append('Access-Control-Allow-Methods', 'POST,PUT,GET,OPTIONS')
            .append('Accept', 'application/json');

        return this.http.get(`${environment.baseUrl}Sell/GetPendingInvoiceToPush`, { params });
    }

    //  Push a pending invoice by reference code
    pushPendingInvoice(referencecode: string, storecode: string) {
        const params = new HttpParams()
            .set('referencecode', referencecode)
            .set('storecode', storecode);

        return this.http.put(`${environment.baseUrl}Sell/PushPendingInvoice`, {}, { params });
    }

}
